{
  "pt": {
    "lot": {
      "attributes": {
        "end_date": "Data final",
        "internal_note": "Nota interna da parcela",
        "land_register": "Registo predial",
        "name": "Nome",
        "start_date": "Data de início",
        "surface": "Área"
      },
      "labels": {
        "lot": "Sem parcela | Uma parcela | {count} Parcelas"
      },
      "toasts": {
        "create": "Enredo criado",
        "delete": "Enredo eliminado",
        "update": "Lote atualizado"
      },
      "validation": {
        "needName": "O título é obrigatório",
        "needNumber": "Deve ser um número (por exemplo, 85)"
      }
    }
  }
}